import ItineraryButtonsEnum from '../../enumerators/itinerary-buttons.enum'

export default class ItineraryButtonsComponent {
    constructor() {
        ItineraryButtonsComponent.initButtonPosition()
    }

    static initButtonPosition() {
        if ($(ItineraryButtonsEnum.BUTTON).length > 0) {
            navigator.geolocation.getCurrentPosition(
                ItineraryButtonsComponent.buildButtonPositionLink,
                ItineraryButtonsComponent.buildButtonPositionLink,
                {
                    enableHighAccuracy: true,
                    timeout: 5000,
                    maximumAge: 250000,
                },
            )
        }
    }

    static buildButtonPositionLink(position) {
        let positionText = ''
        let positionLat = ''
        let positionLng = ''

        if (
            position !== null &&
            typeof position !== 'undefined' &&
            typeof position.coords !== 'undefined'
        ) {
            positionText = 'Ma%20position'
            positionLat = position.coords.latitude.toString().replace(',', '.')
            positionLng = position.coords.longitude.toString().replace(',', '.')
        }

        let link = $(ItineraryButtonsEnum.BUTTON).attr('href')
        link = link.replaceAll('##mapositiontext##', positionText)
        link = link.replaceAll('##positionlat##', positionLat)
        link = link.replaceAll('##positionlng##', positionLng)
        $(ItineraryButtonsEnum.BUTTON).attr('href', link)
    }
}
